export default {
  header: {
    position: 'sticky',
    top: '40px',
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    // padding: '8px 0',
    padding: '16px 24px 16px 24px',
    justifyContent: 'space-between',
    alignΣelf: 'stretch',
    backgroundColor: (theme) => theme.palette.white.paper,
  },
  headerOptions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  titleText: {
    color: (theme) => theme.palette.grays.gray700,
    fontWeight: 700,
    fontSize: '30px',
    lineHeight: '32px',
  },
  arrows: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
  },
  today: {
    display: 'flex',
    padding: '11px 20px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    color: (theme) => theme.palette.grays.gray900,
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '18px',
    border: (theme) => `1px solid ${theme.palette.blues.primaryBlue500}`,
    borderRadius: '100px',
    cursor: 'pointer',
  },
};
